import { RedoSupportRpcClient } from "@redotech/redo-merchant-support-rpc/client";
import { ManagedUserRoles } from "@redotech/redo-model/roles";
import { ShopperAiSettingsOptimizationType } from "@redotech/redo-model/shopper-ai-settings-optimization";
import { GetUser } from "@redotech/redo-model/user";
import { TeamContextValue } from "@redotech/redo-web/context/team-context";
import { ComponentType } from "react";

export interface OptimizationProps {
  handleComplete: () => Promise<void>;
  handleDismiss: () => Promise<void>;
}

type TeamType = NonNullable<TeamContextValue>;

export interface SettingsOptimizationDefinition {
  type: ShopperAiSettingsOptimizationType;
  priority: number; //0 is the highest priority, higher numbers are lower priority
  retries: number; //number of times an optimization will be suggested
  isEligible: (
    team: TeamType,
    user: GetUser | undefined,
    supportRpcClient: RedoSupportRpcClient | undefined,
  ) => Promise<boolean>;
  component: ComponentType<OptimizationProps>;
}

export function checkBaseEligibility(user: GetUser | undefined): boolean {
  const currentPath = window.location.pathname;
  const shouldShowOnRoute = currentPath.includes("support");

  if (!shouldShowOnRoute) {
    return false;
  }

  // TODO: Change to permission check
  if (!user || !user.managedUserRoles.includes(ManagedUserRoles.ADMIN)) {
    return false;
  }

  return true;
}
